import { useNavigate } from 'react-router-dom';
import { Button } from '@app/components/Button/Button';
import DocumentAttachmentIcon from '@app/assets/icons/document-attachment.svg?react';

interface DocumentItem {
  id: string;
  title: string;
  description: string;
  path: string;
}

const documents: DocumentItem[] = [
  {
    id: '1',
    title: 'Getting Started with EchoRatings',
    description: 'First steps after signup to start collecting reviews',
    path: '/documentation/getting-started',
  },
  {
    id: '2',
    title: 'Navigating the Dashboard',
    description: 'Understand the main areas of your dashboard',
    path: '/documentation/dashboard',
  },
  {
    id: '3',
    title: 'Connect Google Reviews',
    description: 'How to connect your Google Business Profile',
    path: '/documentation/connect-google',
  },
  {
    id: '4',
    title: 'Account Roles and Access',
    description: 'Understanding user roles and permissions',
    path: '/documentation/account-roles',
  },
  {
    id: '5',
    title: 'Where to Find Help',
    description: 'How to get help inside EchoRatings',
    path: '/documentation/help',
  },
];

export const Documentation = () => {
  const navigate = useNavigate();

  return (
    <div className="p-4 sm:p-6 lg:p-10 lg:mx-6">
      <h1 className="text-2xl font-bold text-base-raisinBlack mb-2">
        Documentation
      </h1>
      <p className="text-base-coolGray mb-8">
        Echo ratings documentation storage
      </p>

      <div className="flex flex-col bg-white">
        {documents.map((doc) => (
          <div
            key={doc.id}
            className="flex items-center justify-between px-4 py-5 border-b border-gray-100 last:border-b-0"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-base-antiFlash rounded-lg flex items-center justify-center">
                <DocumentAttachmentIcon className="w-6 h-6 text-base-coolGray" />
              </div>
              <div>
                <h3 className="font-semibold text-base-raisinBlack">
                  {doc.title}
                </h3>
                <p className="text-sm text-base-coolGray">{doc.description}</p>
              </div>
            </div>
            <Button
              className="!px-4 !py-1.5 !text-sm !min-w-0"
              onClick={() => navigate(doc.path)}
            >
              Open
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
